import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

// @desc for the animation of Arrow
export const ArrowAnimation = ({ children }) => {
  const arrowRef = useRef(null);
  const isInView = useInView(arrowRef, { once: true });

  const mainControls = useAnimation();

  const animationVariant = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
  }, [isInView, mainControls]);

  return (
    <div ref={arrowRef} style={{ position: 'relative', overflow: 'hidden' }}>
      <motion.div
        variants={animationVariant}
        initial='hidden'
        animate={mainControls}
        transition={{ duration: 1, delay: 0.75 }}
      >
        {children}
      </motion.div>
    </div>
  );
};
